import EventEmitter from 'eventemitter4';

export default new EventEmitter();



// WEBPACK FOOTER //
// ./src/utilities/event.js